import {
  ADD_CAMERA,
  IS_ANNOTATION,
  CHECK_IMAGE,
  CAMERA_DATA,
  ZONE_DATA,
  SELECTED_CAMERA,
  NEW_ZONES,
  SHOW_ZONE_INPUT,
  POLYGON_DETAILS,
  SAVED_POLYGONS,
  VIDEO_PLAYING,
  POLYGON_TYPE,
  POLYGON_COMPLETE,
  DELETE_POLYGON,
  CLEAR_ALL_POLYGONS,
  SET_ZONE_NAME,
  SET_BORDER_LINE_NAME,
  SET_CAMERA_IMAGE,
  CAMERA_ADDED,
  RESET_CAMERA_ADDED
} from './actions';

export const initialState = {
  addCamera: false,
  isAnnotation: false,
  checkImage: false,
  cameraData: {
    store_name: 'Seawoods Nexus Mall',
    device_name: '',
    camera_address: '',
    active: '',
    process_skip_frame: 0
  },
  zoneData: {},
  selectedCamera: {},
  polygonDetails: {},
  savedPolygons: [],
  mode: '',
  videoPlaying: false,
  polygonType: null,
  polygonData: {
    zones: {},
    frisking_line: {}
  },
  zoneNames: [],
  zoneColors: {},
  borderLineNames: [],
  borderLineColors: {},
  cameraImage: null,
  cameraAdded: false
};

// const getRandomColor = () => {
//   const colors = [
//     '#FF6B6B',
//     '#4ECDC4',
//     '#45B7D1',
//     '#96CEB4',
//     '#FFEEAD',
//     '#D4A5A5',
//     '#9B59B6',
//     '#3498DB',
//     '#E67E22',
//     '#1ABC9C',
//     '#F1C40F',
//     '#E74C3C',
//     '#2ECC71',
//     '#F39C12',
//     '#8E44AD'
//   ];
//   return colors[Math.floor(Math.random() * colors.length)];
// };

const videoComponentReducer = (state = initialState, action) => {
  // let updatedZoneNames;

  switch (action.type) {
    case ADD_CAMERA:
      return {
        ...state,
        addCamera: action.payload.addCamera,
        mode: action.payload.mode
      };
    case 'SET_CAMERA':
      return { ...state, cameraData: action.cameraData };
    case IS_ANNOTATION:
      return {
        ...state,
        isAnnotation: action.isAnnotation
      };
    case CHECK_IMAGE:
      return {
        ...state,
        checkImage: action.checkImage
      };
    case CAMERA_DATA:
      return {
        ...state,
        cameraData: action.cameraData
      };
    case ZONE_DATA:
      return {
        ...state,
        zoneData: action.zoneData
      };
    case SELECTED_CAMERA:
      return {
        ...state,
        selectedCamera: action.selectedCamera
      };
    case NEW_ZONES:
      return {
        ...state,
        newZones: action.newZones
      };
    case SHOW_ZONE_INPUT:
      return {
        ...state,
        showZoneInput: action.showZoneInput
      };
    case POLYGON_DETAILS:
      return {
        ...state,
        polygonDetails: action.polygonDetails
      };
    case SAVED_POLYGONS:
      return {
        ...state,
        savedPolygons: action.savedPolygons
      };
    case VIDEO_PLAYING:
      return {
        ...state,
        videoPlaying: action.videoPlaying
      };
    case POLYGON_TYPE:
      return {
        ...state,
        polygonType: action.polygonType
      };
    case POLYGON_COMPLETE: {
      const { type, coordinates } = action.payload;
      const name = type === 'zones' ? state.zoneNames[state.zoneNames.length - 1] : state.borderLineNames[state.borderLineNames.length - 1];

      return {
        ...state,
        polygonData: {
          ...state.polygonData,
          [type]: {
            ...state.polygonData[type],
            [name]: coordinates
          }
        }
      };
    }
    case SET_ZONE_NAME:
      return {
        ...state,
        zoneNames: [...state.zoneNames, action.payload.name],
        zoneColors: {
          ...state.zoneColors,
          [action.payload.name]: action.payload.color
        }
      };
    case SET_BORDER_LINE_NAME:
      return {
        ...state,
        borderLineNames: [...state.borderLineNames, action.payload.name],
        borderLineColors: {
          ...state.borderLineColors,
          [action.payload.name]: action.payload.color
        }
      };
    case DELETE_POLYGON: {
      const updatedZoneNames = [...state.zoneNames];
      const updatedBorderLineNames = [...state.borderLineNames];
      const updatedZoneColors = { ...state.zoneColors };
      const updatedBorderLineColors = { ...state.borderLineColors };

      if (action.payload.type === 'zones') {
        const deletedZoneName = updatedZoneNames[action.payload.index];
        updatedZoneNames.splice(action.payload.index, 1);
        delete updatedZoneColors[deletedZoneName];
      } else if (action.payload.type === 'frisking_line') {
        const deletedBorderLineName = updatedBorderLineNames[action.payload.index];
        updatedBorderLineNames.splice(action.payload.index, 1);
        delete updatedBorderLineColors[deletedBorderLineName];
      }

      return {
        ...state,
        zoneNames: updatedZoneNames,
        borderLineNames: updatedBorderLineNames,
        zoneColors: updatedZoneColors,
        borderLineColors: updatedBorderLineColors,
        polygonData: {
          ...state.polygonData,
          [action.payload.type]: Object.keys(state.polygonData[action.payload.type])
            .filter((_, index) => index !== action.payload.index)
            .reduce((acc, key) => ({ ...acc, [key]: state.polygonData[action.payload.type][key] }), {})
        }
      };
    }
    case CLEAR_ALL_POLYGONS:
      return {
        ...state,
        polygonData: {
          zones: {},
          frisking_line: {}
        },
        zoneNames: [],
        zoneColors: {},
        borderLineNames: [],
        borderLineColors: {}
      };
    case SET_CAMERA_IMAGE:
      return {
        ...state,
        cameraImage: action.payload
      };
    case CAMERA_ADDED:
      return {
        ...state,
        cameraAdded: true,
        addCamera: false // Close the add camera modal
      };
    case RESET_CAMERA_ADDED:
      return {
        ...state,
        cameraAdded: false
      };
    default:
      return state;
  }
};

export default videoComponentReducer;
